import React from 'react'

const Inputs =({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  required = false,
  className = "",
  ...rest
}) => {
  return (
    <div className="w-full space-y-2">
      {label && (
        <label className="text-md font-medium text-gray-800">
          {label}
        </label>
      )}

      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`w-full px-4 py-3 bg-[#eee] text-black rounded-lg 
        border border-gray-700 
        focus:outline-none focus:ring-2 focus:ring-gray-500 
        focus:border-transparent 
        transition-all duration-300 ${className}`}
        {...rest}
      />
    </div>
  )
}

export default Inputs
